import values from 'lodash/values';
import isUndefined from 'lodash/isUndefined';

import createSort from '../../../shared/table/create-sort.js';

const defaultInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'ID',
			direction: 'desc',
			className: 'id'
		},
		date: {
			index: 'date',
			title: 'Time',
			direction: 'desc',
			className: 'date'
		},
		title: {
			index: 'title',
			title: 'Title',
			direction: 'desc',
			className: 'title modify_border'
		},
		news_offers: {
			index: 'news_offers',
			title: 'Offer',
			className: 'offer'
		},
		news_locations: {
			index: 'news_locations',
			title: 'Countries',
			className: 'offer'
		},
		actions: {
			title: 'Actions',
			className: 'actions'
		}
	},
	sortByColumn: {
		index: 'date',
		title: 'Time',
		direction: 'desc'
	},
	shownNewsOffers: {}
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {

	const sort = createSort(namespace, stateNodeName, {
		type: configureSort.type,
		resolverSortFn: configureSort.resolverSortFn
	});

	// action types
	const TOGGLE_NEWS_OFFERS = `${namespace}/table-toggle-news-offers`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = Object.assign({
		toggleNewsOffers: rowIndex => ({
			type: TOGGLE_NEWS_OFFERS,
			payload: rowIndex
		})
	}, sort.actions);

	// reducers
	const reducers = Object.assign({
		[TOGGLE_NEWS_OFFERS]: (state, action) => {
			const { shownNewsOffers } = state.table;
			const rowIndex = action.payload;
			const doShowAllOffers = !isUndefined(shownNewsOffers[rowIndex])
				? !shownNewsOffers[rowIndex]
				: true;

			return {
				...state,
				table: {
					...state.table,
					shownNewsOffers: {
						...state.table.shownNewsOffers,
						[rowIndex]: doShowAllOffers
					}
				}
			};
		}
	}, sort.reducers);

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];

			return {
				headers: values(table.columns),
				rows: rows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length,
				shownNewsOffers: table.shownNewsOffers
			};
		}
	};

	return {
		initialState,
		selectors,
		actions,
		reducers
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/components/table/index.js